import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import Login from "../views/Login";
import Dashboard from "../views/Dashboard";
import Home from "../components/Dashboard/Home";
import AddApp from "../components/Dashboard/Appoitments/AddNew";
import AddBlock from "@/components/Dashboard/Block/AddBlock";
import AddBlockInner from "../components/Dashboard/Appoitments/AppAdd";
import AppInfo from "../components/Dashboard/Appoitments/AppInfo";
import AppEdit from "../components/Dashboard/Appoitments/EditApp";
import SurgAdd from "../components/Dashboard/Surgery/SurgAdd";
import SurgConfirm from "../components/Dashboard/Surgery/SurgerySummary/SurgApprove";
import SurgInfo from "../components/Dashboard/Surgery/SurgInfo";
import SurgEdit from "../components/Dashboard/Surgery/SurgEdit";
import SurgAddStart from "../components/Dashboard/Surgery/AddNew";
import Profile from "../views/Profile";
import ProfileEdit from "../views/ProfileEdit";
import Lobby from "../views/Lobby";
import AlarmPage from "@/views/AlarmPage";
import TimeUpdate from "@/views/TimeUpdate";
import AppTypeUpdate from "@/views/AppTypeUpdate";
import EditBlock from "@/components/Dashboard/Block/EditBlock";
import DeleteBlock from "@/components/Dashboard/Block/DeleteBlock";
import SurgAddBlock from "@/components/Dashboard/Surgery/SurgAddBlock";
import AppSummery from "@/components/Dashboard/Appoitments/AppSummery";
import AppAddSummery from "@/components/Dashboard/Appoitments/AppAddSummery";
import SummeryPage from "@/views/SummeryPage";
import Table from "@/views/Table";
import Contact from "@/views/Contact";
import Messages from "@/views/Messages";
import LicensePlateForm from "@/views/LicensePlateForm";
import CellosignIframe from "@/views/CellosignIframe";
import Cellosign from "@/views/Cellosign";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/dashboard",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Home
      },
      {
        path: "surgeries",
        name: "surgeries",
        component: Home,
        children: [{ path: "list", name: "surgeries-list", component: Home }]
      },
      {
        path: "calendar",
        name: "calendar",
        component: Home
      },
      {
        path: "list",
        name: "list",
        component: Home
      }
    ]
  },
  {
    path: "/add-block",
    name: "add-block",
    component: AddBlock
  },
  {
    path: "/surg-add-block",
    name: "surg-add-block",
    component: SurgAddBlock
  },
  {
    path: "/edit-block/:id",
    name: "edit-block",
    component: EditBlock
  },
  {
    path: "/delete-block/:id",
    name: "delete-block",
    component: DeleteBlock
  },
  {
    path: "/app-add",
    name: "app-add",
    component: AddApp
  },
  {
    path: "/app-add-info",
    name: "app-add-info",
    component: AddBlockInner
  },
  {
    path: "/app-info/:id",
    name: "app-info",
    component: AppInfo
  },
  {
    path: "/app-summery/:id",
    name: "app-summery",
    component: AppSummery
  },
  {
    path: "/app-add-summery/:id",
    name: "app-add-summery",
    component: AppAddSummery
  },
  {
    path: "/app-edit/:id",
    name: "app-edit",
    component: AppEdit
  },
  {
    path: "/time-update/:id",
    name: "time-update",
    component: TimeUpdate
  },
  {
    path: "/app-type-update/:id",
    name: "app-type-update",
    component: AppTypeUpdate
  },
  {
    path: "/surg-add",
    name: "surg-add",
    component: SurgAddStart
  },
  {
    path: "/surg-add-info",
    name: "surg-add-info",
    component: SurgAdd
  },
  {
    path: "/surg-confirm",
    name: "surg-confirm",
    component: SurgConfirm
  },
  {
    path: "/surg-edit/:id",
    name: "surg-edit",
    component: SurgEdit
  },
  {
    path: "/surg-info/:id",
    name: "surg-info",
    component: SurgInfo
  },
  {
    path: "/cellosign-iframe/:type/:id?",
    name: "cellosign-iframe",
    component: CellosignIframe
  },
  {
    path: "/pending-appointments",
    name: "pending-appointments",
    component: AlarmPage
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact
  },
  {
    path: "/messages",
    name: "messages",
    component: Messages
  },
  {
    path: "/license-plate",
    name: "license-plate",
    component: LicensePlateForm
  },
  {
    path: "/summery-page",
    name: "summery-page",
    component: SummeryPage
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile
  },
  {
    path: "/profile-edit",
    name: "profile-edit",
    component: ProfileEdit
  },
  {
    path: "/lobby",
    name: "lobby",
    component: Lobby
  },
  {
    path: "/table/:type",
    name: "table",
    component: Table
  },
  {
    path: "/cellosign",
    name: "cellosign",
    component: Cellosign
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  router.prevRoute = from;
  const user = JSON.parse(localStorage.getItem("hmc-user"));

  // handle session out 401/logout
  if (!user && to.name != "Login") {
    store.dispatch("LOGOUT");

    // set initial route
    const initialRoute = sessionStorage.getItem("initial-route");
    const currentPath = to.fullPath;
    if (!initialRoute && currentPath !== "/") {
      sessionStorage.setItem("initial-route", currentPath);
    }

    next({ name: "Login" });
    return;
  }

  // handle if user logged in & current route is '/' - login
  if (to.name == "Login" && !from.name && user && user.user_id) {
    // Go to last route if exists
    const initialRoute = sessionStorage.getItem("initial-route");
    if (initialRoute) {
      next(initialRoute);
      sessionStorage.removeItem("initial-route");
      return;
    }

    // For mobile/desktop first entrance is different
    const isMobile = window.innerWidth < 1200;
    if (isMobile) {
      next({ name: "lobby" });
    } else {
      next({ name: "Dashboard" });
    }
    return;
  }

  next();
  return;
});

router.afterEach((to, from) => {
  store.commit("CLOSE_MENU");
});

export default router;
